var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.uniqueSowTypes),function(ref){
var key = ref.key;
var sow_po_number = ref.sow_po_number;
var sow_type = ref.sow_type;
return _c('AssignmentsTable',{key:key,staticClass:"mb-4",attrs:{"title":((sow_po_number || '...') + ", " + (sow_type || '...')),"items":_vm.assignmentsMap[key]}})}),(_vm.investedAssignments.length)?_c('AssignmentsTable',{attrs:{"is-invested":"","items":_vm.investedAssignments}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }